import create from "zustand";

import StorageHandler from "../../../../utils/StorageHandler";
import Validator from "../../../../utils/validation/Validator";

const storage = new StorageHandler();
const validator = new Validator();

/**
 * If the user didn't sent something or the last sending ist older or equals 5 minutes ago,
 * he can send again.
 */
const canSend = (timestamp) => {
    if (timestamp === null) {
        return true;
    }
    return Math.floor((Date.now() - parseInt(timestamp)) / 1000 / 60) >= 5;
};

const useStore = create((set, get) => ({
    initialize: (formName, fields) => {
        const formData = {};
        fields.forEach((item) => {
            formData[item.name] = {
                name: item.name,
                placeholder: item.placeholder,
                required: item.required,
                validation: item.validation,
                value: "",
            };
        });

        set({
            formName: formName,
            storageKey: `${formName}:contact-form:data`,
            formData,
            emailSent: !canSend(
                storage.get(formName + ":contact-form:sent-at", null)
            ),
        });
    },
    formName: null,
    storageKey: null,
    formData: {},
    sending: false,
    emailSent: false,
    sendingError: false,
    errors: [],
    onChange: (event) => {
        set((state) => ({
            formData: {
                ...state.formData,
                ...{
                    [event.target.name]: {
                        ...state.formData[event.target.name],
                        value: event.target.value,
                    },
                },
            },
        }));
    },
    dataIsValid: () => {
        const state = get();
        const errors = [];
        let isValid = true;

        Object.keys(state.formData).forEach((key) => {
            if (
                state.formData[key].validation ||
                state.formData[key].required
            ) {
                let fieldIsValid = () => true;

                if (state.formData[key].validation) {
                    fieldIsValid = validator.getValidator(
                        state.formData[key].validation,
                        state.formData[key].value,
                        !!state.formData[key].required
                    );
                }

                if (!fieldIsValid()) {
                    isValid = false;
                    errors.push(key);
                }
            }
        });

        set({ errors: errors });

        // If the data is valid, store it in the local storage.
        if (isValid) {
            storage.setJson(state.storageKey, state.formData);
        }
        return isValid;
    },
    setErrors: (errors) => set({ errors }),
    setSending: (sending) => set({ sending }),
    setSendingError: (sendingError) => set({ sendingError }),
    setEmailSent: (emailSent) => set({ emailSent }),
    addFormError: (error) =>
        set((state) => {
            if (state.errors.includes(error)) {
                return state;
            }
            return { errors: [...state.errors, error] };
        }),
    clearError: (error) =>
        set((state) => ({
            errors: state.errors.filter((item) => item !== error),
        })),
    hasErrorAt: (error) => get().errors.includes(error),
}));

export default useStore;
